export interface MercureUpdate<T = unknown> {
  readonly id: string;
  readonly topic: string;
  readonly data: T;
  readonly receivedAt: Date;
  readonly retry?: number;
  readonly type?: string;
}

export function createMercureUpdate<T = unknown> (params: {
  id: string;
  topic: string;
  data: T;
  receivedAt: Date;
  retry?: number;
  type?: string;
}): MercureUpdate<T> {
  return {
    id: params.id,
    topic: params.topic,
    data: params.data,
    receivedAt: params.receivedAt,
    retry: params.retry,
    type: params.type,
  };
}
